import React from 'react';
import classNames from 'classnames';
import { Shimmer, ShimmerElementType } from '@fluentui/react';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

const getAdAssetsFormShimmer = () => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    width: '100%',
    gap: '16px',
  },
  title: {
    marginBottom: '8px',
  },
  description: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    gap: '8px',
    width: '100%',
    marginBottom: '16px',

    '& div:not(:last-child)': {
      width: '100%',
    },
  },
  section: {
    width: '100%',
  },
});

export const AdAssetsFormShimmer = () => {
  const classes = useDefaultStyles(getAdAssetsFormShimmer);

  return (
    <div className={classNames('ad-assets-form-shimmer', classes.container)}>
      <Shimmer
        className={classes.title}
        shimmerElements={[{ type: ShimmerElementType.line, height: 36, width: 260 }]}
      />
      <div className={classes.description}>
        <Shimmer shimmerElements={[{ type: ShimmerElementType.line, height: 16, width: '100%' }]} />
        <Shimmer shimmerElements={[{ type: ShimmerElementType.line, height: 16, width: '100%' }]} />
        <Shimmer shimmerElements={[{ type: ShimmerElementType.line, height: 16, width: 320 }]} />
      </div>
      <Shimmer
        className={classes.section}
        shimmerElements={[{ type: ShimmerElementType.line, height: 128, width: '100%' }]}
      />
      <Shimmer
        className={classes.section}
        shimmerElements={[{ type: ShimmerElementType.line, height: 224, width: '100%' }]}
      />
      <Shimmer
        className={classes.section}
        shimmerElements={[{ type: ShimmerElementType.line, height: 196, width: '100%' }]}
      />
    </div>
  );
};

const getAdAssetsPreviewerShimmerStyles = () => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    width: '400px',
    gap: '8px',
  },
});

export const AdAssetsPreviewerShimmer = () => {
  const classes = useDefaultStyles(getAdAssetsPreviewerShimmerStyles);

  return (
    <div className={classNames('ad-assets-previewer-shimmer', classes.container)}>
      <Shimmer
        shimmerElements={[
          { type: ShimmerElementType.line, height: 36, width: 50 },
          { type: ShimmerElementType.gap, width: 8 },
          { type: ShimmerElementType.line, height: 36, width: 65 },
          { type: ShimmerElementType.gap, width: 8 },
          { type: ShimmerElementType.line, height: 36, width: 45 },
          { type: ShimmerElementType.gap, width: 8 },
          { type: ShimmerElementType.line, height: 36, width: 55 },
        ]}
      />
      <Shimmer shimmerElements={[{ type: ShimmerElementType.line, height: 450, width: 420 }]} />
    </div>
  );
};

